<template>
    <div class="grid grid-cols-1 gap-x-4 gap-y-3 px-4 py-2 sm:grid-cols-2 sm:px-6">
        <h3
            :class="[
                'col-span-2 pb-1 text-base font-semibold',
                { 'required': isRequiredLegalComplianceProfileAttribute('tax_situation', 'tax_situation') },
            ]">
            Entity’s tax situation
        </h3>

        <BaseInputCheckbox
            v-model="formValues.tax_situation.capital_gains"
            :label="$t('country_tax_residencies.capital_gains_legal')"
            name="tax_situation.tax_situation.capital_gains"></BaseInputCheckbox>
        <BaseInputCheckbox
            v-model="formValues.tax_situation.corporate_tax_exemption"
            :label="$t('country_tax_residencies.corporate_tax_exemption')"
            name="tax_situation.tax_situation.corporate_tax_exemption"></BaseInputCheckbox>
        <BaseInputCheckbox
            v-model="formValues.tax_situation.group_taxation"
            :label="$t('country_tax_residencies.group_taxation')"
            name="tax_situation.tax_situation.group_taxation"></BaseInputCheckbox>
        <BaseInputCheckbox
            v-model="formValues.tax_situation.foreign_assets"
            :label="$t('country_tax_residencies.foreign_assets')"
            name="tax_situation.tax_situation.foreign_assets"></BaseInputCheckbox>

        <BaseInputTextActivatable
            v-model="formValues.tax_situation.other"
            name="tax_situation.tax_situation.other"
            label="Other:"></BaseInputTextActivatable>
    </div>
</template>

<script setup lang="ts">
import { isRequiredLegalComplianceProfileAttribute, LegalTaxSituation } from '../forms'
import { useVModel } from '@vueuse/core'
import BaseInputTextActivatable from '../../../../../base/BaseInputTextActivatable.vue'
import BaseInputCheckbox from '../../../../../base/BaseInputCheckbox.vue'

const props = defineProps<{
    modelValue: LegalTaxSituation
}>()
const emit = defineEmits(['update:modelValue'])

const formValues = useVModel(props, 'modelValue', emit)
</script>
